import { render, staticRenderFns } from "./Contratti.vue?vue&type=template&id=01cf1635&"
import script from "./Contratti.vue?vue&type=script&lang=js&"
export * from "./Contratti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports